// extracted by mini-css-extract-plugin
export var sectionstep = "stepProducts-module--sectionstep--8fOif";
export var title = "stepProducts-module--title--1SQlW";
export var steps = "stepProducts-module--steps--YgbZ7";
export var step = "stepProducts-module--step--GCqSa";
export var stepText = "stepProducts-module--stepText--ogSSo";
export var stepSubtitle = "stepProducts-module--stepSubtitle--cee5O";